import { defaultAxios, isNetSuccess } from '@/utils';

export const fetchNoticeList: () => Promise<any[]> = async () => {
    const [d, e] = await defaultAxios.get('/crm/notice/select');
    if (isNetSuccess(d, e)) {
        return d.data;
    }
    return [];
};

export const saveNotice: (params: any) => Promise<any> = async params => {
    const [d, e] = await defaultAxios.put('/crm/notice/save', {
        ...params,
    });
    if (isNetSuccess(d, e)) {
        return d.data;
    }
    return null;
};

export const deleteNotice: (id: string) => Promise<any> = async id => {
    const [d, e] = await defaultAxios.delete('/crm/notice/delete', undefined, {
        params: {
            id,
        },
    });
    if (isNetSuccess(d, e)) {
        return d.data;
    }
    return null;
};
